import { MDXLayout as Layout } from "@/shared/components/MDX/MDXLayout";
import { Alert } from "@/shared/components/MDX/MDXComponents";

# راهنمای داشبورد انبار

این صفحه نمای کلی از وضعیت انبارها، موجودی و میانبرهای دسترسی سریع به بخش‌های مختلف انبار را در اختیار شما قرار می‌دهد.

## ۱. دسترسی سریع
از طریق پنل‌های موجود می‌توانید به سرعت به لیست متریال‌ها، پالت‌ها، و تنظیمات انبار دسترسی پیدا کنید.

## ۲. گزارشات کلی
مهم‌ترین آمار و ارقام انبار (تعداد تراکنش‌های باز، موجودی‌های رو به اتمام و ...) در این صفحه به صورت خلاصه قابل مشاهده است.

export default Layout;
